import { FormikProps } from 'formik'
import React, { useState } from 'react'
import ModalComponent from '..'
import { POSOrderDetails } from '../../../features/pos-module'
import { useGetAllCustomersQuery } from '../../../redux-toolkits/user/user.slice'
import { CustomersQuery } from '../../../redux-toolkits/customers/customers.type'
import { Button } from '../../button'
import { Checkbox } from '../../inputs/Checkbox'
import ComboBox from '../../inputs/combobox'
import { TextInput } from '../../inputs/textInput'

export const POSCustomerDetails: React.FC<{
  open: boolean
  setOpen: (cal: boolean) => void
  onCloseCallback?: () => void
  onSuccessCallback?: () => void
  formik: FormikProps<POSOrderDetails>
}> = ({
  open,
  setOpen,
  onCloseCallback = () => {},
  onSuccessCallback = () => {},
  formik,
}) => {
  const [query, setQuery] = useState<CustomersQuery>({
    skip: 0,
    limit: 10,
    search: undefined,
    deleted: undefined,
    startDate: undefined,
    endDate: undefined,
    sort: 'fully_onboarded',
    isCustomDateRange: false,
    filter: 'inception_to_date',
  })

  const { values, errors, handleChange, handleBlur, touched, setValues } =
    formik

  const { data: customers, isFetching: fetchingCustomers } =
    useGetAllCustomersQuery(query, {
      refetchOnMountOrArgChange: true,
      skip: !open,
    })

  return (
    <ModalComponent
      open={open}
      setOpen={setOpen}
      onCloseCallback={() => {
        onCloseCallback()
        setValues({
          ...values,
          customerEmail: '',
          customerPhone: '',
          customerName: '',
          customerId: '',
          createGoodAccount: false,
        })
      }}
      title={'Customer details'}
      childrenClassName="md:!max-w-[420px]"
    >
      <div className="flex flex-col items-center justify-center gap-4">
        <ComboBox
          type="text"
          name="customerEmail"
          value={values.customerEmail}
          onChange={handleChange}
          onBlur={handleBlur}
          hasIcon={false}
          placeholder="Email"
          errors={
            touched.customerEmail && errors.customerEmail
              ? errors.customerEmail
              : ''
          }
          menuItemsClassName=""
          menuItems={
            customers?.data?.customers?.map((cust) => ({
              name: (
                <span>
                  <span className="capitalize">
                    {cust.firstname} {cust.lastname}
                  </span>{' '}
                  • {cust.email}
                </span>
              ),
              value: {
                name: `${cust.firstname} ${cust.lastname}`,
                phone: `${cust.phoneNumber ?? ''}`,
                email: `${cust.email ?? ''}`,
                id: `${cust._id ?? ''}`,
              },
            })) ?? []
          }
          onSelectOption={(selected) => {
            setValues(
              {
                ...values,
                customerEmail: selected?.email,
                customerPhone: selected?.phone,
                customerName: selected?.name,
                customerId: selected?.id,
              },
              true,
            )
          }}
          onSearch={(val) => {
            setQuery({
              ...query,
              search: val || undefined,
            })
          }}
          loading={fetchingCustomers}
          immediate
          position="bottom start"
          menuClassName="!max-h-[250px] !z-[999] shadow-md"
          className="w-full"
        />

        <TextInput
          type="text"
          name="customerPhone"
          value={values.customerPhone}
          onChange={handleChange}
          onBlur={handleBlur}
          hasIcon={false}
          placeholder="Phone number (optional)"
          errors={
            touched.customerPhone && errors.customerPhone
              ? errors.customerPhone
              : ''
          }
        />

        <TextInput
          type="text"
          name="customerName"
          value={values.customerName}
          onChange={handleChange}
          onBlur={handleBlur}
          hasIcon={false}
          placeholder="Name (optional)"
          errors={
            touched.customerName && errors.customerName
              ? errors.customerName
              : ''
          }
          inputClass="!capitalize"
        />

        <TextInput
          type="text"
          name="tableNumber"
          value={values.tableNumber}
          onChange={handleChange}
          onBlur={handleBlur}
          hasIcon={false}
          placeholder="Table number (optional)"
          errors={
            touched.tableNumber && errors.tableNumber ? errors.tableNumber : ''
          }
        />

        <div className="flexx !hidden flex-row w-full justify-start ">
          <Checkbox
            checkStatus={values?.createGoodAccount ?? false}
            handleChange={(status: boolean) => {
              setValues({
                ...values,
                createGoodAccount: status,
              })
            }}
            key={`create-good-account-checkbox`}
            text="Create a Good Account"
          />
        </div>

        <Button
          label="Continue"
          type="button"
          className="mt-2 w-full"
          disabled={
            !!errors.customerEmail ||
            !!errors.customerName ||
            !!errors.customerPhone
          }
          loading={false}
          primary
          onClick={() => {
            onSuccessCallback()
          }}
        />
      </div>
    </ModalComponent>
  )
}
